@if (data$ | async; as data) {
  <div class="simple-product-list-title">
    {{data.title}}
  </div>
  <div class="simple-product-list-items">
    @if (products$ | async; as products) {
      @for (product of products | slice:0:data.maxProducts; track product; let i = $index) {
        <div [class]="'product product-'+i">
          @if ( product | async; as prod) {
            <app-custom-simple-product-item [item]="prod"></app-custom-simple-product-item>
          }
        </div>
      }
    }
  </div>
}
